/**
 * The `results` capability keys — the server's EXACT capability strings (server/src/modules/results/
 * routes.js). Every mutating action is gated on one of these via useCan; the server re-checks each
 * request (these only hide/show UI). Keep this the single source so screens never inline a raw string.
 */
export const RESULTS_CAPS = {
  /** Read a compte-rendu (GET /results/comptes-rendus/:id). Gates the whole module. */
  read: "results.compterendu.read",
  /** Emit a compte-rendu from a demande (POST /results/demandes/:id/emettre). */
  create: "results.compterendu.create",
  /** Render/print the governed comptoir artifact (GET /results/comptes-rendus/:id/imprimer). */
  print: "results.compterendu.print",
  /** Deliver / hold-release a diffusion channel (POST /results/canaux/:id/delivrer|liberer). */
  release: "results.canal.release",
  /** NOVA-054 — the comptoir desk-recall worklist (GET /results/recall + POST /results/recall/:id/recuperer). */
  recall: "results.canal.recall",
} as const;

export type ResultsCapability = (typeof RESULTS_CAPS)[keyof typeof RESULTS_CAPS];
